import '@components/StepConfigurator/Steps/Select'
import '@components/StepConfigurator/Steps/Filter'
import '@components/StepConfigurator/Steps/Aggregate'
import '@components/StepConfigurator/Steps/Join'
import '@components/StepConfigurator/Steps/CustomTransform'
import '@components/StepConfigurator/Steps/CustomExpand'
import '@components/StepConfigurator/Steps/Limit'
import '@components/StepConfigurator/Steps/Sort'
import '@components/StepConfigurator/Steps/Union'
import '@components/StepConfigurator/Steps/History'